import React from "react";
import ReactDOM from "react-dom/client";
import { PublicClientApplication, EventType, InteractionRequiredAuthError } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";
import App from "./App";

const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.initialize().then(() => {
  // Set active account if one exists
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
  }

  // Listen for login success
  msalInstance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload?.account) {
      msalInstance.setActiveAccount(event.payload.account);
    }

    // If interaction is required (session expired), redirect to login
    if (
      event.eventType === EventType.ACQUIRE_TOKEN_FAILURE &&
      event.error instanceof InteractionRequiredAuthError
    ) {
      // Clear stale state and trigger fresh login
      localStorage.clear();
      sessionStorage.clear();
      msalInstance.loginRedirect().catch(() => {
        msalInstance.loginPopup().catch(console.error);
      });
    }
  });

  ReactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </React.StrictMode>
  );
});
